interface DiscordLinkParams {
    text?: string
}

export function DiscordLink({text = 'Discord'}: DiscordLinkParams) {
    return <a href='https://discord.gg/NR7pGp3QWr' target='blank'>{text}</a>
}
